import React, { useEffect, useState, useContext } from 'react'
import { Link } from "react-router-dom"
import { Oval } from 'react-loader-spinner'
import ModalEmpleadoGerente from '../../Modales/Admin/empresa/ModalEmpleadoGerente'
import ModalAreaGerente from '../../Modales/Admin/empresa/ModalAreaGerente';
import { Modal } from 'react-bootstrap';
import { useAdmin } from '../../../context/AdminContext';
import { AreaContext } from '../../../context/AreaContext';
import "./VistaGerenteAdmin.scss"

export const vistaGerenteContext = React.createContext()

function VistaGerenteAdmin(props) {

  const { areas, setAreas } = useContext(AreaContext)

  const { 
    empleados, 
    loadingEmpleado, 
    setLoadingEmpleado, 
    fetchEmpleadosById, 
    errorEmpleado,
    fetchArea, 
    errorArea,
    setErrorArea,
  } = useAdmin()

  // EMPLEADO
  const [modalEmpleado, setModalEmpleado] = useState(false)
  const [objEmpleado, setObjEmpleado] = useState(null)
  const [idEmpleado, setIdEmpleado] = useState(null)
  const [modalDelete, setModalDelete] = useState(false)
  const [errorDel, setErrorDel] = useState(null)

  // AREAS
  const [modalArea, setModalArea] = useState(false)
  const [objArea, setObjArea] = useState(null)
  const [idArea, setIdArea] = useState(null)

  const [loadingAreas, setLoadingAreas] = useState(true)

  useEffect(()=>{

    fetchEmpleadosById(props.user, props.user.idEmpresa)

    fetchArea(props.user, user.idEmpresa)
    .then(res => {
        if(res.status !== 0){
          setLoadingAreas(false)
          setErrorArea(res.codeError)
        } else {
          setLoadingAreas(false)
          setAreas(res.objeto)
        }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  // LÓGICA AREA
  const handleModalArea = () => {
    setModalArea(true)
  }

  const handleModalEditArea = (id) => {
    const obj = areas.find((e) => e.id_area === id)
    setObjArea(JSON.stringify(obj))
    setIdArea(id)
    setModalArea(true)
  }

  // LÓGICA EMPLEADO
  const handleModalEmpleado = () => {
    setModalEmpleado(true)
  }

  // EDITAR EMPLEADO
  const handleModalEditEmpleado = (id) => {
    const obj = empleados.find((e) => e.id_empleado === id)
    setObjEmpleado(JSON.stringify(obj))
    setIdEmpleado(id)
    setModalEmpleado(true)
  }

  // DELETE EMPLEADO
  const handleModalDeleteEmpleado = (id) => {
    setIdEmpleado(id)
    setModalDelete(true)
  }

  const closeDeleteEmpleado = () => {
    setModalDelete(false)
    setIdEmpleado(null)
  }

  const handleDeleteEmpleado = async () => {
    const obj = {
      user,
      idUser: parseInt(idEmpleado),
    }
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/deleteUser`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(obj)
      })
      const data = await res.json()
      if(data.status !== 0){
        setErrorDel(data.codeError)
      } else {
        closeDeleteEmpleado()
        // actualizar empleados
        setLoadingEmpleado(true)
        fetchEmpleadosById(user, user.idEmpresa)
      }
    } catch (error) {
      setErrorDel("Error: Conexión con backend.")
    }
  }

  const user = props.user

  return (
    <>
      <vistaGerenteContext.Provider value={{ user, idEmpleado, setIdEmpleado, objEmpleado, setObjEmpleado, areas, idArea, setIdArea, objArea, setObjArea }}>
        <ModalAreaGerente show={modalArea} onHide={()=>setModalArea(false)} animation={false} dialogClassName="custom-fade-modal" />
        <ModalEmpleadoGerente show={modalEmpleado} onHide={()=>setModalEmpleado(false)} animation={false} dialogClassName="custom-fade-modal" />
          {/* Modal Eliminar empleado */}
          <Modal className='modal__delete' show={modalDelete} onHide={closeDeleteEmpleado} backdrop="static" centered animation={false} >
            <Modal.Header closeButton>
              <Modal.Title><h3>Eliminar empleado/a</h3></Modal.Title>
            </Modal.Header>
            <Modal.Body>¿Está seguro de eliminar este empleado/a?</Modal.Body>
            <Modal.Footer className='d-flex flex-column'>
              <div className='d-flex flex-row align-items-center align-self-end'>
                  <button className='btn btn-secondary rounded-pill me-2' onClick={closeDeleteEmpleado}>Cancelar</button>
                  <button className='btn btn-danger rounded-pill' onClick={handleDeleteEmpleado}>Borrar</button>
              </div>
              {errorDel && <p>{errorDel}</p>}
            </Modal.Footer>
          </Modal>
          <div className='mb-3 d-flex flex-row justify-content-end'>
            <Link className='ms-auto btn btn-sm btn-primary rounded-pill px-3 fw-medium' to={'/admin/empleados/flowchart'}>Ver Flowchart</Link>
          </div>
          <div className='containerGerente__listas scroll--y scroll--x'>
            {loadingAreas ? (
              <div className='loading__GerenteAdmin--areas d-flex flex-column align-items-center justify-content-center'>
                <Oval
                  visible={true}
                  height="80"
                  width="80"
                  color="#0d6efd"
                  ariaLabel="oval-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
                <p className='fw-medium'>Loading...</p>
              </div>
            ) : (
              <>
                {errorArea ? (
                  <div className='error__VistaGerente--areas py-4 d-flex flex-column align-items-center justify-content-center rounded-3'>
                    <h3 className='text-danger fw-semibold mb-2'>Oops!</h3>
                    <p className='m-0 p-0'>{errorArea}</p>
                  </div>
                ) : (
                  <>
                    {areas.length === 0 ? (
                      <div className='container__areas--empty py-4 d-flex flex-column align-items-center justify-content-center rounded-3'>
                          <h3 className='text-blue-500'>No tienes áreas aún.</h3>
                          <button onClick={handleModalArea} className='btn btn-sm btn-primary rounded-pill px-3 fw-medium'>+ Agregar área</button>
                      </div>
                    ) : (
                      <div className='container__areas'>
                        <div className='d-flex flex-row align-items-center mb-4'>
                          <h4 className='text-blue-500 m-0 pe-3'>Áreas</h4>
                          <button onClick={handleModalArea} className='btn btn-sm btn-primary rounded-pill px-3 fw-medium'>+ Agregar área</button>
                        </div>
                        <div className='table__customA'>
                          <div className='table__customA__header'>
                            <div className='table__customA__cell fw-bold text-blue-500 cellA__buttons'></div>
                            <div className='table__customA__cell fw-bold text-blue-500 cellA__id text-center'>#</div>
                            <div className='table__customA__cell fw-bold text-blue-500 cellA__name'>Nombre</div>
                          </div>
                          <div className='table__customA__body'>
                            {areas.map((a,i) => {
                              return <div key={i} className='d-flex flex-row'>
                              <div className='table__customA__row'>
                                  <div className='table__customA__cell cellA__buttons'>
                                      <button onClick={()=>handleModalEditArea(a.id_area)} className='btn__ico--g btn border-0 p-0 btn__edit--icon'><i className="bi bi-pencil"></i></button>
                                  </div>
                                  <div className='table__customA__cell cellA__id fw-bold text-center text-blue-500'>{a.id_area}</div>
                                  <div className='table__customA__cell cellA__name'>{a.nombre_del_Area}</div>
                              </div>
                              </div>
                            })}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
            {loadingEmpleado ? (
              <div className='loading__GerenteAdmin--empleados d-flex flex-column align-items-center justify-content-center'>
                <Oval
                  visible={true}
                  height="80"
                  width="80"
                  color="#0d6efd"
                  ariaLabel="oval-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
                <p className='fw-medium'>Loading...</p>
              </div>
            ) : (
              <>
                {errorEmpleado ? (
                  <div className='error__VistaGerente--empleados py-4 d-flex flex-column align-items-center justify-content-center rounded-3'>
                    <h3 className='text-danger fw-semibold mb-2'>Oops!</h3>
                    <p className='m-0 p-0'>{errorEmpleado}</p>
                  </div>
                ) : (
                  <>
                    {empleados.length === 0 ? (
                      <div className='container__usuarios--empty py-4 d-flex flex-column align-items-center justify-content-center rounded-3'>
                          <h3 className='text-blue-500'>No tienes empleados aún.</h3>
                          <button onClick={handleModalEmpleado} className='btn btn-sm btn-success rounded-pill px-3 fw-medium'>+ Agregar empleado</button>
                      </div>
                    ) : (
                      <div className='container__usuarios'>
                        <div className='d-flex flex-row align-items-center mb-4'>
                          <h4 className='text-green m-0 pe-3'>Empleados</h4>
                          <button onClick={handleModalEmpleado} className='btn btn-sm btn-success rounded-pill px-3 fw-medium'>+ Agregar empleado</button>
                        </div>
                        <div className='table__customU--alt'>
                          <div className='table__customU--alt__header'>
                            <div className='table__customU--alt__cell fw-bold cellU__buttons text-green'></div>
                            <div className='table__customU--alt__cell fw-bold cellU__id text-center text-green'>#</div>
                            <div className='table__customU--alt__cell fw-bold cellU__name text-green'>Nombre</div>
                            <div className='table__customU--alt__cell fw-bold cellU__mail text-green'>Email</div>
                            <div className='table__customU--alt__cell fw-bold cellU__fecha text-green'>Fecha de creación</div>
                            <div className='table__customU--alt__cell fw-bold cellU__puesto text-green'>Puesto</div>
                            <div className='table__customU--alt__cell fw-bold cellU__area text-green'>Área</div>
                          </div>
                          <div className='table__customU--alt__body'>
                            {empleados.map((e,i) => {
                              return <div key={i} className='d-flex flex-row'>
                                <div className='table__customU--alt__row'>
                                  <div className='table__customU--alt__cell cellU__buttons'>
                                    <button onClick={()=>handleModalEditEmpleado(e.id_empleado)} className='btn__ico--g btn border-0 p-0 btn__edit--icon'><i className="bi bi-pencil"></i></button>
                                    <button onClick={()=>handleModalDeleteEmpleado(e.id_empleado)} className='btn__ico--g btn border-0 p-0 btn__delete--icon'><i className="bi bi-trash3"></i></button>
                                  </div>
                                  <div className='table__customU--alt__cell cellU__id fw-bold text-center text-green'>{e.id_empleado}</div>
                                  <div className='table__customU--alt__cell cellU__name'>{e.nombre}</div>
                                  <div className='table__customU--alt__cell cellU__mail'>{e.mail}</div>
                                  <div className='table__customU--alt__cell cellU__fecha'>{e.fecha_de_creacion}</div>
                                  <div className='table__customU--alt__cell cellU__puesto'>
                                    {e.fk_puesto === 1 && "Administrador"}
                                    {e.fk_puesto === 2 && "Consultora"}
                                    {e.fk_puesto === 3 && "Gerente"}
                                    {e.fk_puesto === 4 && "Jefe de Área"}
                                    {e.fk_puesto === 5 && "Empleado"}
                                    {e.fk_puesto === 6 && "Aprobador de muestras"}
                                    {e.fk_puesto === 7 && "Auditor externo"}
                                  </div>
                                  <div className='table__customU--alt__cell cellU__area'>
                                    {areas.find(a => a.id_area === e.fk_area)?.nombre_del_Area}
                                  </div>
                                </div>
                              </div>
                            })}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
      </vistaGerenteContext.Provider>
    </>
  )
}

export default VistaGerenteAdmin